import { ApiResponse } from "types";
import { IConfiguration } from "interfaces";
import { Apis, Enums } from "utils";

export interface IConfigurationData {
  all(): Promise<ApiResponse<IConfiguration[]>>;
  find(id: string): Promise<ApiResponse<IConfiguration>>;
}

export class ConfigurationData implements IConfigurationData {
  private collection = "configs";

  async all(): Promise<ApiResponse<IConfiguration[]>> {
    try {
      const response = await Apis.current().get(`${this.collection}`);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IConfiguration[]>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IConfiguration[]>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IConfiguration[]>;
    }
  }


  async find(id: string): Promise<ApiResponse<IConfiguration>> {
    try {
      const response = await Apis.current().post(`${this.collection}/find`, { _id: id } as any);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IConfiguration>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IConfiguration>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IConfiguration>;
    }
  }
}